/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from 'react';
import {Color, Label, Row} from 'trux';
import './FullVideoWarning.css';

export const FullVideoWarning = ({marginTop = 0, expirationDays}) => {
  return (
    <Row marginTop={marginTop}>
      <Label
        className="download-expire-warning"
        type={Label.Type.Body}
        color={Color.Black}
        spacing="4"
        content={
          <Row alignItems="center">
            <Label><b>Warning:&nbsp;</b>This full game download will expire in<b>&nbsp;{expirationDays}&nbsp;days.&nbsp;</b>
              You will still be able to watch the game and
              download all individual moments as long as you have a Trace subscription.</Label>
          </Row>
        }
      />
    </Row>
  )
}